import { Placeholder, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { Tabs } from '@ahc-digital/component-library';
import { GetN08TabModel } from './N08Tabs.service';
import { TAB_CONTAINER_VALUE } from 'src/shared/static';
import { translationClasses } from 'src/shared/TranslationClasses';
import { N08TabsProps } from './N08Tabs.types';
import { SwitchToPreviewMessage } from 'src/shared/SwitchToPreviewMessage';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: N08TabsProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return isEditing ? (
    <SwitchToPreviewMessage componentName={props?.rendering?.componentName}>
      <div>
        {props?.rendering && <Placeholder name={TAB_CONTAINER_VALUE} rendering={props.rendering} />}
      </div>
    </SwitchToPreviewMessage>
  ) : (
    <Tabs
      {...GetN08TabModel(props)}
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
    />
  );
};
